// extracted by mini-css-extract-plugin
export default {"featuresContainer":"Features_featuresContainer__zRp-p","featuresImgBox":"Features_featuresImgBox__sm+Cs","parentBoxofLoader":"Features_parentBoxofLoader__jqqsr"};